import React, {ReactNode, useMemo} from 'react';
import {FormControl, FormLabel, Typography} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {DropzoneArea} from "react-mui-dropzone";
import {Nil} from "../../utils/Types";
import clsx from "clsx";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {Trans} from "react-i18next";

interface IProps {
    required?: boolean
    label: ReactNode,
    value: File | Nil,
    onChange: (newValue: File | Nil) => void
}

const useStyles = makeStyles({
    fileUpload: {
        display: "flex",
        alignItems: "center",
        minHeight: "3rem",
        "& > .MuiDropzoneArea-textContainer": {
            display: "flex",
            alignItems: "center",
            "& > *": {
                paddingLeft: "0.5rem"
            }
        },
        "& > *": {
            paddingLeft: "0.5rem"
        }
    },
    textNotVisible: {
        "& > .MuiDropzoneArea-textContainer": {
            display: "none",
        },
    },
    notVisible: {
        display: "none",
    }
});

export const FileInput: React.FC<IProps> = ({required, label, value, onChange}) => {
    const classes = useStyles();
    const Text: React.ComponentType = useMemo(() => {
        return () => <>
            <Typography variant={"subtitle1"}><Trans i18nKey="common.dropzone">Drag and drop a file here or click</Trans></Typography><CloudUploadIcon/>
        </>
    }, [])
    return <>
        <FormControl fullWidth>
            <FormLabel required={required}>
                {label}
            </FormLabel>
            <DropzoneArea
                    dropzoneClass={clsx(value ? classes.textNotVisible : "", classes.fileUpload)}
                    dropzoneParagraphClass={classes.notVisible}
                    Icon={Text}
                    maxFileSize={4500000} //4.5MB
                    filesLimit={1}
                    showPreviews={false}
                    showPreviewsInDropzone={true}
                    useChipsForPreview={true}
                    showFileNamesInPreview={true}
                    initialFiles={value ? [value] : []}
                    onChange={(files) => {
                        if (files.length === 1) {
                            onChange(files[0])
                        } else {
                            onChange(undefined)
                        }
                    }}
            />
        </FormControl>
    </>
}

export default FileInput
